import '.aj{flex-shrink:0;}.ssr-plugin'
import '.a2{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ao{height:100%;}.ssr-plugin'
import '.al{border:none;}.ssr-plugin'
import '.do{background-color:transparent;}.ssr-plugin'
import '.dp{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.bl{position:sticky;}.ssr-plugin'
import '.dq{top:4rem;}.ssr-plugin'
import '.dr{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ds{padding-bottom:1rem;}.ssr-plugin'
import '.d9{margin-bottom:1rem;}.ssr-plugin'
import '.dt{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bm{top:0px;}.ssr-plugin'
import '.bt{left:0px;}.ssr-plugin'
import '.bu{right:0px;}.ssr-plugin'
import '.bv{bottom:0px;}.ssr-plugin'
import '.du{z-index:9999;}.ssr-plugin'
import '.dv{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bk{justify-content:flex-end;}.ssr-plugin'
import '.ap{flex:1;}.ssr-plugin'
import '.c4{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="aj a2 n ao al do dp"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e af"
    >
      <div className="bl dq dr t ds d9 dt d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bm bt bu bv du t dv d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="a2 d bk dt"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ap c4">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
